import React from 'react'
import Numeral from 'numeral'

import { Bar } from 'recharts'

import transform from '../transform'
import colors from 'lib/colors'
import Empty from 'components/charts/empty'
import ChartContainer from 'components/charts/container'
import { APIGW_ERRORS } from 'containers/inventory/details/resource/metrics-tabs/services/apigateway'

const ApigatewayErrorsChart = ({ loading, data, height, span }) => {
  if (loading || !data) return null

  const metrics = transform({
    [APIGW_ERRORS]: data.APIGATEWAY_ERRORS_5XX,
    errorsClient: data.APIGATEWAY_ERRORS_4XX
  })

  if (!metrics.length) return <Empty height={height} />

  const tooltipFormatter = (value, name, props) => {
    return [Numeral(value).format('0.[000]a'), undefined]
  }

  return (
    <ChartContainer height={height}
      data={metrics}
      yTicksFormatting='0'
      span={span}
      tabKey={APIGW_ERRORS}
      formatTab={value => `${Numeral(value).format('0.[000]a')}`}
      formatTooltip={tooltipFormatter}
    >
      <Bar dataKey='errorsClient' stackId='a' fill={colors('chart', 'redLight')} name='4XX Errors' barSize={4} />
      <Bar dataKey={APIGW_ERRORS} stackId='a' fill={colors('chart', 'red')} name='5XX Errors' />
    </ChartContainer>
  )
}

export default ApigatewayErrorsChart
